export const FORWARD = 'FORWARD';
export const PLAY = 'PLAY';
export const REWIND= 'REWIND';
export const PAUSE = 'PAUSE';
export const RESTART = 'RESTART';

export const forward = (value=1) => ({
    name: "Forward",
    type: FORWARD,
    value
});

export const rewind = (value=1) => ({
    name: "Rewind",
    type: REWIND,
    value
});

export const pause = () => ({
    name: "Pause",
    type: PAUSE,
});

export const restart = () => ({
    name: "Restart",
    type: RESTART,
});

export const play = () => ({
    name: "Play",
    type: PLAY,
});
